<div class="container-fluid mt-3">
  <div class="scroll-data" (scroll)="onScroll($event)">
    @for (blog of blogs; track $index) {
    <div class="card" (click)="blogIddata(blog._id)">
      <img
        [src]="blog.img || '/assets/logo/chessx-light-main-logo.svg'"
        alt="Blog Image"
        class="card-img-top"
      />
      <div class="card-body">
        <h5 class="card-title">{{ blog.title }}</h5>
        <p class="card-date">{{ blog.date }}</p>
        <p class="card-text">
          {{
            isExpanded[blog._id]
              ? blog.body
              : (blog.body | slice : 0 : 150) + "..."
          }}
          <span class="view-more"> View More </span>
        </p>
      </div>
    </div>
    }
  </div>
</div>
